import { GrowpIcon } from 'packages/components/GrowpIcon'
import { PermEnum } from 'packages/sdks-next/growp'
import { MenuItemUnion } from 'packages/web-layout/types'

/**
 * 门户管理菜单配置
 *
 * @returns 配置
 */
export const useGatewayManagementMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/gatewayManagement',
      label: (
        <GrowpIcon
          name="Menhu"
          text="门户管理"
          size={14}
          textMarginLeft={16}
        />
      ),
      labelText: '门户管理',
      height: 40,
      perm: PermEnum.Gateway,
    },
  ]
}
